import { gql } from '@apollo/client';
import { CreateUserInput } from './types';
import { User } from '../../queries/users/types';

/**
 * GraphQL mutation to create a new user
 */
export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      user {
        id
        databaseId
        name
        email
        username
        roles {
          nodes {
            name
          }
        }
      }
    }
  }
`;

export interface CreateUserData {
  createUser: {
    user: User;
  };
}

export interface CreateUserVariables {
  input: CreateUserInput;
}
